import React, { useState } from 'react'
import { Switch, Box } from '@mui/material'

import { withStyles } from '@mui/styles'

import { usePublicOfferContext } from '../../contexts'
import { publicOfferStateSwitchStyles } from './public-offer-state-switch.styles'

export const StatePublicOfferStateSwitch = withStyles(publicOfferStateSwitchStyles)(({
  classes,
  ...props
}) => {
  const { changePublicOfferStatus } = usePublicOfferContext()

  if (!props.rowData) {
    return null
  }

  const state = props.rowData['activa']
  const publicOfferId = props.rowData['id']

  const [loading, setLoading] = useState(false)

  const handleToggleState = (e) => {
    e.stopPropagation()
    setLoading(true)
    changePublicOfferStatus(publicOfferId, { activa: e.target.checked })
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const columnStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <Box sx={columnStyles} onClick={(e) => e.stopPropagation()}>
      <Switch classes={classes} checked={state} disabled={loading} onChange={handleToggleState} />
    </Box>
  )
})
